import mitt from 'mitt'
import trace from 'app-core/lib/trace'
const store = new Map()
window.$pubsub = {
  mode: localStorage.getItem('pubsub_mode') || 'prod',
  /**
   * @description Get a channel
   * @param {string} namespace
   * @returns {Object}
   */
  getChannel: (namespace) => {
    if (!store.has(namespace)) {
      return null
    }
    return store.get(namespace)
  },

  /**
   * @description Get all channels
   * @returns {string[]}
   */
  allChannels: () => {
    return Array.from(store.keys())
  },

  /**
   * @description Create a new channel
   * @param {string} namespace
   * @returns {Object}
   */
  channel: (namespace) => {
    if (!store.has(namespace)) {
      const emitter = mitt()
      let currentMessage = null
      store.set(namespace, {
        _trace: [],
        /**
         * @description 获取最新消息
         * @returns {Object}
         */
        getLatestMessage: () => {
          return _.cloneDeep(currentMessage)
        },
        /**
         * @description 订阅
         * @param {string} key
         * @param {Function} callback
         */
        on: (key, callback) => {
          emitter.on(key, callback)
        },
        /**
         * @description 取消订阅
         * @param {string} key
         * @param {Function} callback
         */
        off: (key, callback) => {
          emitter.off(key, callback)
        },
        /**
         * @description 发布消息
         * @param {string} action
         * @param {Object} message
         */
        emit: (action, message) => {
          const msg = _.cloneDeep({ action, message })
          emitter.emit(action, message)
          currentMessage = msg
          trace.tag('pubsub', {
            data: msg,
            namespace,
            action,
            message
          })
          if (window.$pubsub.mode === 'dev') {
            store.get(namespace)._trace.push(msg)
          }
        }
      })
    }
    return store.get(namespace)
  }
}

// const ai = window.pubsub.channel('ai')
// const train = window.pubsub.channel('train')
// train.on('action', (e) => {
//   console.log('train Action', e)
//   ai.emit('action2', e)
// })

// ai.on('action2', (e) => {
//   console.log('ai Action', e)
// })

// train.emit('action', { a: 'b' })
// console.log('action Store', window.pubsub.getStore('ai'))
// console.log('action Store', window.pubsub.getStore('ai').getLatestMessage())
// window.train = train
